import { noop } from 'lodash';
import { createContext, useContext } from 'react';

import { User } from '../model/user';

export interface ImpersonationState {
  loggedInUser?: User;
  users: User[];
  impersonatedUser?: User;
  setImpersonatedUser: (user: User | undefined) => void;
  currentUser?: User;
}

export const ImpersonationContext = createContext<ImpersonationState>({
  users: [],
  setImpersonatedUser: noop,
});

export const useImpersonation = (): ImpersonationState => {
  return useContext(ImpersonationContext);
};
